import { render, staticRenderFns } from "./YzFilePreview.vue?vue&type=template&id=052b7032&scoped=true&lang=pug&"
import script from "./YzFilePreview.vue?vue&type=script&lang=js&"
export * from "./YzFilePreview.vue?vue&type=script&lang=js&"
import style0 from "./YzFilePreview.vue?vue&type=style&index=0&id=052b7032&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "052b7032",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VProgressCircular})
